import parse from "html-react-parser";
import React from "react";

interface SidebarCalloutsProps {
  sidebarCallouts: {
    id: string;
    lineItems?: { id: string; text: string; title: string | null }[];
    heading?: string;
    summary?: string;
    quotation?: string;
    attribution?: string;
    role?: string;
    typeHandle?: string;
  }[];
  isTour?: boolean;
}

const SidebarCalloutsComponent: React.FC<SidebarCalloutsProps> = ({
  sidebarCallouts,
  isTour
}) => {
  const sectionStyle = {
    backgroundColor: isTour ? "#fff" : "#F6F6F9",
    paddingTop: "20px",
    paddingBottom: "20px",
    paddingLeft: "22px",
    paddingRight: "22px",
  };

  const numberStyle = {
    // fontFamily: "Inter",
    fontSize: "52px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "60px",
    color: "#6863F2",
  };

  const headingStyle = {
    // fontFamily: "Inter",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    color: "#6863F2",
  };

  const quoteStyle = {
    // fontFamily: "TWK Everett",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "55px",
    color: "#924E8C",
  };

  const attibuteStyle = {
    // fontFamily: "TWK Everett",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#924E8C",
  };

  return (
    <>
      {sidebarCallouts.map((callout, index) => {
        return (
          <div key={callout.id} className="callout__item">
            {/* Line Items */}
            {callout.lineItems && (
              <ul style={sectionStyle}>
                {callout.lineItems.map((item) => (
                  <li key={item.id}>
                    <span style={{ fontWeight: "bold" }}>{item.label}: </span>
                    {item.text}
                  </li>
                ))}
              </ul>
            )}

            {/* Heading & Summary - also Number & Summary */}
            {callout.typeHandle === "heading" && callout.heading && (
              <div style={sectionStyle}>
                <h4 className="" style={headingStyle}>
                  {callout.heading}
                </h4>
                <p>{callout.summary}</p>
              </div>
            )}

            {/* Number & Summary */}
            {callout.typeHandle === "number" && callout.heading && (
              <div style={sectionStyle}>
                <h4 className="" style={numberStyle}>
                  {callout.heading}
                </h4>
                <p>{callout.summary}</p>
              </div>
            )}

            {/* Quotes */}
            {callout.quotation && (
              <blockquote style={sectionStyle}>
                <div
                  style={quoteStyle}
                >
                   {parse(callout.quotation)}
                </div>
                <cite style={attibuteStyle}>
                  — {callout.attribution}, {callout.role}
                </cite>
              </blockquote>
            )}
          </div>
        );
      })}
    </>
  );
};

export default SidebarCalloutsComponent;
